<template>

        <teleport v-if="got_data" to="#fav-ctrls">
            <div>
                <div :class="{starred: is_starred, clicked: is_starred_clicked}" @click="toggleStarred"></div>
            </div>
        </teleport>

        <span id="skip-start-btn" :class="{show: show_skip_start_btn, initialized: skip_start_btn_initialized}" @click="skipTo"><span>skip intro</span></span>

<!--    <div class="container video-player">-->
        <vue-plyr ref="plyr" :emit="['canplaythrough']" @canplaythrough="canPlayThrough()" :options="playerOptions" crossorigin="anonymous">
            <video></video>
        <!--  <video poster="poster.png" src="https://player.vimeo.com/external/259334144.hd.mp4?s=703862aa1ddaeefd295bc18c426459e2ffbade17&profile_id=175">-->
        <!--    <source src="https://player.vimeo.com/external/259334144.hd.mp4?s=703862aa1ddaeefd295bc18c426459e2ffbade17&profile_id=175" type="video/mp4" size="720">-->
        <!--    <source src="https://player.vimeo.com/external/259334144.hd.mp4?s=703862aa1ddaeefd295bc18c426459e2ffbade17&profile_id=175" type="video/mp4" size="1080">-->
<!--            <track kind="captions" label="English" srclang="en" src="https://captions.cloud.vimeo.com/captions/19839922.vtt?expires=1656713717&sig=96eedd4b4f3463dcb481a0d44b04839a50519e2c&download=auto_generated_captions.vtt&hls=1" default>-->
        <!--  </video>-->
        </vue-plyr>
<!--    </div>-->

</template>

<script>

import Hls from 'hls.js';

export default {
	props: [
	    'vimeo_id',
        'hls_is_supported', // or is preferred by user
    ],
	data(){
        return {
        	got_data: false,
            is_starred: null,
            is_starred_clicked: null,
            playerOptions: {
                controls: [
                	'play-large',
                	'play',
                    'progress',
                    'volume',
                    'captions',
                    'fullscreen',
                    'settings'
                ],
                settings: [
                    'quality',
                    // 'captions'
                ],
                quality: {
                	'default': 1080
                },
                storage: {
                	'enabled': false
                },
                captions: {
                    active: false,
                    language: 'auto',
                    update: true,
                }
            },
            is_playing: false,
            is_seeking: false,
            in_transition: false,
            current_drill_index: 0,
            hls: null,
            show_skip_start_btn: false,
            skip_start_btn_initialized: false
        }
    },
    computed: {
	    player() {
		    return this.$refs.plyr.player
	    },
    },
    mounted(){

		this.got_data = true;

        this.getWorkoutLibraryVid(this.vimeo_id, this.hls_is_supported).then((response)=>{

            // const source = response.data.video_data.source;
            this.player.poster = response.data.video_data.poster;

            this.is_starred = response.data.is_starred;

            this.skip_start = response.data.skip_start;

            $('#workout-lib-vid-title').text(response.data.video_data.title);
            $('#workout-lib-vid-desc').text(response.data.video_data.description);

            this.$nextTick(()=>{

                switch(this.hls_is_supported){
                    case true:
                        this.hls = new Hls();
                        this.hls.loadSource(response.data.video_data.sources);
                        this.hls.attachMedia(this.player.media);

                        // Handle changing captions
                        this.player.on('languagechange', () => {
                            // Caption support is still flaky. See: https://github.com/sampotts/plyr/issues/994

                            // console.log(this.player.currentTrack);

                            setTimeout(()=>{
                                this.player.toggleCaptions();
                                this.hls.subtitleTrack = this.player.currentTrack
                            },50);

                            setTimeout(()=>{
                                this.player.toggleCaptions();
                            },100);

                        });

                        break;
                    case false:

                    	this.player.source = response.data.video_data;
                      this.hideLoader();
                    	break;
                }

                let endFuncBound = false;

                this.player.on('playing',()=>{

                	// weird firefox bug fix
                    // 'try' because dunno how else to test if captions exist; throws an error "s not defined" if not
                        setTimeout(()=>{
                            try{this.player.toggleCaptions()}catch(e){}
                        },50);

                        setTimeout(()=>{
                            try{this.player.toggleCaptions()}catch(e){}
                        },100);

                	this.skip_start_btn_initialized = true;
                    this.checkSkipStartVisibility();

                    if(!endFuncBound)
                    {
                    	endFuncBound = true;

                    	// const min_time = process.env.NODE_ENV === 'development' ? 1 : 300000; // 5 minutes
                    	const min_time = process.env.NODE_ENV === 'development' ? 1 : (response.data.video_data.duration / 3)*1000; // 1/3rd of the duration in ms

                        setTimeout( ()=>{

                            // if played for at least 60 seconds, bind end function
                            this.player.on('ended', ()=>{

                                this.pingWorkoutVideoCompleted(response.data.video_data);
                            });
                        },min_time);
                    }
                });

                this.player.on('seeked', ()=>{
                    this.checkSkipStartVisibility();
                })

            });
        });
    },
    methods: {
		checkSkipStartVisibility()
        {
            if(this.skip_start && (this.player.currentTime < this.skip_start))
            {
                this.show_skip_start_btn = true;
                this.runCycleToRemoveSkipStartBtn();
            }else {
                this.show_skip_start_btn = false;
            }
        },
		runCycleToRemoveSkipStartBtn()
        {
        	clearTimeout(this.run);
        	this.run = setTimeout(()=>{

                if(!this.player.playing)
                    return false;

		        if(this.player.currentTime >= this.skip_start){
			        this.show_skip_start_btn = false;
			        return false;
		        }
                this.runCycleToRemoveSkipStartBtn();
            },1000);
        },
        skipTo()
        {
            this.player.currentTime = this.skip_start;
        },
		canPlayThrough(){
            this.hideLoader();
        },
        toggleStarred()
        {
            this.toggleWorkoutLibraryFavorite(this.vimeo_id, this.is_starred);

        	this.is_starred = !this.is_starred;
        	if(this.is_starred){
        		this.is_starred_clicked = true;
        		setTimeout(()=>{
        			this.is_starred_clicked = false;
                },500);
            }
        }
        // allowHeightAdjust(){
        //     const $el = $('.container.video-player');
        //     $el.css('height', 'auto');
        //     this.$nextTick(()=>{
        //         this.fixHeight();
        //     })
        // },
        // fixHeight(){
        //     const $el = $('.container.video-player');
        //     const h = $el.outerHeight();
        //     $el.css('height', h + 'px');
        // }
    }
}

</script>
